export class ReportSelection {

    dateFrom: Date;
    dateUntil: Date;
    stationGroupId: number;
    stationSetId: number;
    carrier: string;

    constructor(selection: ReportSelection) {
        this.dateFrom = selection.dateFrom;
        this.dateUntil = selection.dateUntil;
        this.stationGroupId = selection.stationGroupId;
        this.stationSetId = selection.stationSetId;
        this.carrier = selection.carrier;
    }

}